import {Task} from "@/shared/timr";
import {TreeDropdown, TreeDropdownConfig, TreeDropdownURLs} from "../ui/treeDropdown";
import {BaseTreeBasicNode} from "@/shared/ui/baseTree";


export interface TaskDropdownConfig extends TreeDropdownConfig {
	allowSelectionOfNotBookable: boolean;
	groupId?: number;
	userId?: number;
	hideInactive: boolean;
}

export class TaskDropdown extends TreeDropdown<Task, TaskDropdownConfig> {

	constructor(config: TaskDropdownConfig, urls: TreeDropdownURLs) {
		super({
			...config,
			minQueryLength: 3,
			emptyTreeMessage: messages[`taskTree.empty.${globals.isTaskManager ? "taskManager" : "noTaskManager"}`],
			noMatchMessage: messages[`taskTree.search.query.nomatch.${globals.isTaskManager ? "taskManager" : "noTaskManager"}`],
			clickFolderMode: config.allowSelectionOfNotBookable ? 4 : 3
		}, urls);
	}

	public setGroupId(groupId: number) {
		if (this.config.groupId !== groupId) {
			this.config.groupId = groupId;
			this.reset();
		}
	}

	public setUserId(userId: number) {
		if (this.config.userId !== userId) {
			this.config.userId = userId;
			this.reset();
		}
	}

	public setHideInactive(hideInactive: boolean) {
		if (this.config.hideInactive !== hideInactive) {
			this.config.hideInactive = hideInactive;
			this.reset();
		}
	}

	public setSelectedTask(task?: Task) {
		if (task) {
			this.setSelection(task.id, task.name, task.breadCrumbs, task);
		} else {
			this.setSelection(null, null, null, null);
		}
	}

	protected isNodeSelectable(data: Task & BaseTreeBasicNode): boolean {
		return !data.dummy && (this.config.allowSelectionOfNotBookable || (data as Task).bookable);
	}

	protected formatNode(data: Task): string {
		return data.name;
	}

	protected getRequestData() {
		return {
			groupId: this.config.groupId,
			userId: this.config.userId,
			hideInactive: this.config.hideInactive,
		};
	}
}
